import { ICopyable, IJsonSerializable, IOpChangeState } from '../util/interfaces'
import { Enums } from '../common/enums'

import { OpConsumer } from './op-consumer'
import { OpPaymentModule } from './op-payment-module'

export class OpConsumerPaymentModule implements IOpChangeState, IJsonSerializable, ICopyable<OpConsumerPaymentModule> {

    // #region Properties

    public idConsumerPaymentModule: number
    public idConsumer: number
    public idPaymentModule: number
    public paymentSystemNumber: string

    // #endregion


    // #region Navigation Properties

    public consumer: OpConsumer
    public paymentModule: OpPaymentModule

    // #endregion


    // #region Custom Properties

    public isActive: boolean

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpConsumerPaymentModule) {
            this.copy(<OpConsumerPaymentModule>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion


    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region JsonSerializable implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idConsumer = opObj.ID_CONSUMER
            this.idConsumerPaymentModule = opObj.ID_CONSUMER_PAYMENT_MODULE
            this.idPaymentModule = opObj.ID_PAYMENT_MODULE
            this.paymentSystemNumber = opObj.PAYMENT_SYSTEM_NUMBER

            this.consumer = opObj._Consumer != null ? new OpConsumer(opObj._Consumer) : null
            this.paymentModule = opObj._PaymentModule != null ? new OpPaymentModule(opObj._PaymentModule) : null

            this.opState = opObj.OpState

            this.isActive = opObj.ID_CONSUMER_PAYMENT_MODULE != 0

        } else {
            this.idConsumerPaymentModule = 0

            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_CONSUMER: this.idConsumer,
            ID_CONSUMER_PAYMENT_MODULE: this.idConsumerPaymentModule,

            ID_PAYMENT_MODULE: this.idPaymentModule,
            PAYMENT_SYSTEM_NUMBER: this.paymentSystemNumber ? this.paymentSystemNumber : null ,

            _Consumer: this.consumer ? this.consumer.toJSON() : null,
            _PaymentModule: this.paymentModule ? this.paymentModule.toJSON() : null,
            OpState: this.opState
        }
    }

    // #endregion


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpConsumerPaymentModule {
        const consumerPaymentModule: OpConsumerPaymentModule = new OpConsumerPaymentModule()

        consumerPaymentModule.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return consumerPaymentModule
    }

    public copy(source: OpConsumerPaymentModule, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.paymentModule = source.paymentModule != null ? source.paymentModule.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null

            this.consumer = source.consumer // TODO Zaimplementować ICopyable 
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idConsumerPaymentModule = source.idConsumerPaymentModule
        this.idConsumer = source.idConsumer
        this.idPaymentModule = source.idPaymentModule
        this.paymentSystemNumber = source.paymentSystemNumber

        this.opState = source.opState
    }

    // #endregion 

}
